import i18next from 'i18next';
window.i18next = i18next;
